import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import depthMove from 'routes/vendorRe/images/depth_move_icon.png';
import { 
    commonBgColor, 
    commonBodyPadding, 
    commonFontWeight700, 
    commonH1Padding, 
    commonH1Size, 
    contentEnd, 
    contentStart,
    infoBorderColor,
    infoEm,
    infoFontColor1,
    infoFontColor2,
    infoFontColor3,
    infoFontColor4,
    infoFontSize1,
    infoFontSize2,
    statsOuterPadding,
    statsPaddingEnd,
    statsPaddingMiddle,
    statsPaddingStart,
    
} from 'routes/vendorRe/constraint/constraints';
import LineChart from 'routes/vendorRe/components/LineChart';
import VendorSaleList from 'routes/vendorRe/components/VendorSaleList';
import DoughChart from 'routes/vendorRe/components/DoughChart';
import VerticalChart from 'routes/vendorRe/components/VerticalChart';
import downChev from 'routes/vendorRe/images/down_chevron.png';
import maleDot from 'routes/vendorRe/images/male_dot.png';
import femailDot from 'routes/vendorRe/images/female_dot.png';
import { requester } from 'App';
import { 
    combineDuplicates, 
    filterDataByThisMonth, 
    filterDataByThisWeek, 
    filterDataByThisYear, 
    filterDataByToday, 
    getDailySales, 
    getTotalAmount 
} from 'routes/vendorRe/commonFn/vendorPurchaseOrder';
import { useNavigate } from 'react-router-dom';

const VendorStats = () => {
    const navigate = useNavigate();
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    
    const [totalWeekEachAmount, setTotalWeekEachAmount] = useState(0);
    const [weekSalesData, setWeekSalesData] = useState([]);
    const [salesOverview, setSalesOverview] = useState();
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.toLocaleString('ko-KR', { month: 'long' });

    useEffect(()=> {
        setMounted(true);
    }, []);
    
    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFee((result) => {
                
                setTotalAmount(result.data)
            })
            requester.getVendorSalesOverview((result) => {
                
                setSalesOverview(result.data);
            })
            requester.getBestSalesTop3((result) => {
                
                setWeekSalesData(result.data);
                // setSalesOverview(result.data);
            })
            requester.getWeeklySalesStatus((result) => {
                
                setTotalWeekEachAmount(result.data);
            })
            

        }
    }, [isMounted]);
    const onSalesClick = () => {
        navigate("/vendor/main/calc");
    }

    return (
        <Container backgroundColor={commonBgColor}>
            <div style={{height: "10vh"}}></div>
            <VerticalFlex>
                <FlexChild padding={commonBodyPadding}>
                    <VerticalFlex alignItems={contentStart}>
                        <FlexChild alignItems={contentStart}>
                            <P padding={commonH1Padding} size={commonH1Size}>매출 &middot; 판매 통계</P>
                            <VerticalFlex backgroundColor="white" borderRadius={infoEm} padding={statsOuterPadding} margin="0 0 2em">
                                <FlexChild padding={statsPaddingStart}>
                                    <HorizontalFlex>
                                        <FlexChild flex="12">
                                            <P weight={commonFontWeight700} size={infoFontSize1} padding="0 1em 0 0">정산 예정 금액</P>
                                            <P size={infoFontSize2} color={infoFontColor4}>( {currentYear}년 {currentMonth} 기준 )</P>
                                        </FlexChild>
                                        <FlexChild flex="1" justifyContent={contentEnd}>
                                            <img onClick={onSalesClick} className={styles.depthMove} src={depthMove} alt='뎁스 이동' />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild flex="3">
                                    <div className={styles.borderTop}>
                                        <VerticalFlex>
                                            <FlexChild padding={statsPaddingMiddle} borderTop={infoBorderColor}>
                                                <HorizontalFlex >
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>이달 매출</P>
                                                    </FlexChild>
                                                    <FlexChild  justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>{totalAmount ? totalAmount.totalPrice.toLocaleString() : 0}</P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>물품 대금</P>
                                                    </FlexChild>
                                                    <FlexChild  justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                        {totalAmount && totalAmount.totalsupplyPrice ? (`- `) + totalAmount.totalsupplyPrice.toLocaleString() : 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild padding={statsPaddingEnd}>
                                                <HorizontalFlex>
                                                    <FlexChild flex="3">
                                                        <P size={infoFontSize1} color={infoFontColor3}>이번달 정산예정 금액</P>
                                                    </FlexChild>
                                                    <FlexChild flex="1" justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor2}>{totalAmount && totalAmount.totalAmount ? totalAmount.totalAmount.toLocaleString() : 0}</P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                            <VerticalFlex backgroundColor="white" borderRadius={infoEm} padding={statsOuterPadding} margin="0 0 2em">
                                <FlexChild alignItems={contentStart} padding={statsPaddingStart}>
                                    <P weight={commonFontWeight700} size={infoFontSize1}>매출현황</P>
                                </FlexChild>
                                <FlexChild>
                                    {/* 라인 그래프 영역 */}
                                    <LineChart totalWeekEachAmount={totalWeekEachAmount} />
                                </FlexChild>
                                <FlexChild>
                                    <div className={styles.borderBottom}>
                                        <HorizontalFlex padding={statsPaddingMiddle}>
                                            <FlexChild>
                                                <P size={infoFontSize2}>오늘 매출</P>
                                            </FlexChild>
                                            <FlexChild justifyContent={contentEnd}>
                                                <P weight={commonFontWeight700} size={infoFontSize1}>{salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0}</P>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </div>
                                    <div className={styles.borderBottom}>
                                        <HorizontalFlex padding={statsPaddingMiddle}>
                                            <FlexChild>
                                                <P size={infoFontSize2}>이번주 매출</P>
                                            </FlexChild>
                                            <FlexChild justifyContent={contentEnd}>
                                                <P weight={commonFontWeight700} size={infoFontSize1}>{salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}</P>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </div>
                                    <div className={styles.borderBottom}>
                                        <HorizontalFlex padding={statsPaddingMiddle}>
                                            <FlexChild>
                                                <P size={infoFontSize2}>이번달 매출</P>
                                            </FlexChild>
                                            <FlexChild justifyContent={contentEnd}>
                                                <P weight={commonFontWeight700} size={infoFontSize1}>{salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}</P>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </div>
                                    <HorizontalFlex padding={statsPaddingEnd}>
                                        <FlexChild>
                                            <P size={infoFontSize2}>올해 매출</P>
                                        </FlexChild>
                                        <FlexChild justifyContent={contentEnd}>
                                            <P weight={commonFontWeight700} size={infoFontSize1}>{salesOverview ? salesOverview.thisYearTotalPrice.toLocaleString() : 0}</P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                            <VerticalFlex margin="0 0 2em">
                                <FlexChild alignItems={contentStart}>
                                    <VerticalFlex backgroundColor="#fff" borderRadius="1em" padding="1.5em">
                                        <FlexChild>
                                            <div style={{fontWeight: commonFontWeight700, fontSize: infoFontSize1, padding: "0 0 24px", borderBottom: infoBorderColor}}>
                                                주간 판매량 BEST 3
                                                {/* <img className={styles.chev} src={downChev} alt='아래 방향' /> */}
                                            </div>
                                            <VerticalFlex height="auto">
                                                {/* 반복 구간 시작*/}
                                                {weekSalesData && weekSalesData.sort((a, b) => b.quantity - a.quantity).map((saleItem, index) => (
                                                    <VendorSaleList key={index} data={saleItem} />
                                                ))}
                                                {/* 반복 구간 끝 */}
                                            </VerticalFlex>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </VerticalFlex>
                            <VerticalFlex backgroundColor="white" borderRadius={infoEm} padding={statsOuterPadding}>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild padding="0 0 1em 0">
                                            <P weight={commonFontWeight700} size={infoFontSize1} padding="0 1em 0 0">구매자 통계</P>
                                            <P size={infoFontSize2} color={infoFontColor4}>(2024년 3월 기준)</P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    {/* 도넛 그래프 영역 */}
                                    <div className={styles.commonPadd}>
                                        <DoughChart />
                                    </div>
                                </FlexChild>
                                <FlexChild>
                                    <VerticalFlex>
                                        <FlexChild>
                                            <div className={styles.maleBox}>
                                                <HorizontalFlex padding={statsPaddingMiddle}>
                                                    <FlexChild>
                                                        <P size={infoFontSize2}>
                                                            <img className={styles.genderDots} src={maleDot} alt='남성' />
                                                            남성
                                                        </P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P size={infoFontSize2}>347명</P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div className={styles.femaleBox}>
                                                <HorizontalFlex padding={statsPaddingMiddle}>
                                                    <FlexChild>
                                                        <P size={infoFontSize2}>
                                                            <img className={styles.genderDots} src={femailDot} alt='여성' />
                                                            여성
                                                        </P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P size={infoFontSize2}>95명</P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </div>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                                <FlexChild padding="2em 0 1em" alignItems={contentStart}>
                                    <P weight={commonFontWeight700} size={infoFontSize1} padding="0 1em 0 0">연령 통계</P>
                                </FlexChild>
                                <FlexChild>
                                    {/* 막대 그래프 영역 */}
                                    <VerticalChart />
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorStats;